/** @jsx jsx */
import { jsx, css } from '@emotion/react'
import { Grid, Typography } from '@mui/material'
import React, { useEffect } from 'react'
import { useResizeDetector } from 'react-resize-detector'
import { Step, Steps } from 'react-step-builder'
import config from '../config'
import analytics from '../libs/analytics'
import steps from './steps'

const INITIAL_HEIGHT = 287
const PADDINGS = 80
const RESIZE_DEBOUNCE_INTERVAL = 25

window.onbeforeunload = function () {
  analytics.sendEvent('Onboard@Close')
  return 'Your changes will be lost if you refresh the page.'
}

function OnboardWizard() {
  const { height = INITIAL_HEIGHT, ref } = useResizeDetector<HTMLDivElement>({
    refreshMode: 'debounce',
    refreshRate: RESIZE_DEBOUNCE_INTERVAL,
  })

  useEffect(() => {
    const handler = (event) => {
      try {
        const data = JSON.parse(event.data)
        if (data.gclid) {
          localStorage.setItem('gclid', data.gclid)
        }
      } catch {}
    }

    window.addEventListener('message', handler)

    return () => window.removeEventListener('message', handler)
  }, [])

  return (
    <Grid ref={ref} justifyContent="center">
      <Typography
        css={css`
          font-size: 10px;
          position: absolute;
          top: 0;
          right: 0;
          color: #b1b1b1;
        `}
      >
        {config.version}
      </Typography>
      <Grid item>
        {window.parent.postMessage(`content---height---${Math.ceil(height) + PADDINGS}px`, config.cmsFrameLink)}
        <Steps>
          <Step title="" component={steps.StepEmail} />
          <Step title="" component={steps.StepProfile} />
          <Step title="" component={steps.StepLogo} />
          <Step title="" component={steps.StepLocations} />
          <Step title="" component={steps.StepPhone} />
          <Step title="" component={steps.StepLogin} />
          <Step title="" component={steps.StepIdentityCheck} />
          <Step title="" component={steps.StepEnd} />
        </Steps>
      </Grid>
    </Grid>
  )
}

export default OnboardWizard
